var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvistlogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 362.602,
    height: 138.322,
    viewBox: "0 0 362.602 138.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14b8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#14b8e1",
    stopOpacity: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#14b8e1",
    stopOpacity: 0.847
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#14b8e1",
    stopOpacity: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#14b8e1",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#14b8e1",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14b8e1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.234,
    y1: -0.523,
    x2: 1.004,
    y2: 1.632,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14b8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#14b8e1",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#14b8e1",
    stopOpacity: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#14b8e1",
    stopOpacity: 0.737
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#14b8e1",
    stopOpacity: 0.537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#14b8e1",
    stopOpacity: 0.286
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#14b8e1",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    transform: "translate(-139.035 -335.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2735",
    "data-name": "Group 2735",
    transform: "translate(139.035 335.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14867",
    "data-name": "Path 14867",
    d: "M141.609,365.08v50.176l78.973,17.79v-97.9Z",
    transform: "translate(-138.215 -335.141)",
    opacity: 0.5,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14868",
    "data-name": "Path 14868",
    d: "M188.9,409.6H141.609l57.254,23.5,27.5-13.1Z",
    transform: "translate(-138.215 -335.696)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14869",
    "data-name": "Path 14869",
    d: "M170.646,359.01v75.4l-31.611-6.894V364.9Z",
    transform: "translate(-139.035 -351.819)",
    fill: "#14b8e1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(71.795 22.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2730-2",
    "data-name": "Group 2730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14870",
    "data-name": "Path 14870",
    d: "M214.535,423.948l-21.057-59.375h20.368l11.909,39.7h.346l12-39.7h19.5l-20.97,59.375Z",
    transform: "translate(-193.478 -363.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14871",
    "data-name": "Path 14871",
    d: "M248.777,423.948V364.573H267.85v59.375Z",
    transform: "translate(-175.853 -363.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14872",
    "data-name": "Path 14872",
    d: "M317.895,368.4q7.333,4.619,7.508,13.679v1.035H307.539v-.345a5.593,5.593,0,0,0-1.9-4.315q-1.9-1.725-5.783-1.726a12.255,12.255,0,0,0-5.826,1.122A3.233,3.233,0,0,0,292,380.616q0,2.33,2.761,3.452a53.138,53.138,0,0,0,8.888,2.329,96.254,96.254,0,0,1,11.781,3.065,20.062,20.062,0,0,1,8.068,5.222q3.452,3.624,3.539,9.838,0,10.529-7.121,15.619t-19.029,5.093q-13.894,0-21.618-4.662t-7.724-16.483h18.036q0,4.488,2.332,6t7.249,1.511a19.576,19.576,0,0,0,6-.777,3.107,3.107,0,0,0,2.374-3.194q0-2.156-2.634-3.236a52.507,52.507,0,0,0-8.586-2.285,98.89,98.89,0,0,1-12-3.237,20.23,20.23,0,0,1-8.284-5.566q-3.539-3.883-3.538-10.529,0-9.75,7.551-14.369t19.116-4.617Q310.559,363.788,317.895,368.4Z",
    transform: "translate(-168.595 -363.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14873",
    "data-name": "Path 14873",
    d: "M321.482,423.948V364.573h19.073v59.375Z",
    transform: "translate(-152.681 -363.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14874",
    "data-name": "Path 14874",
    d: "M381.524,379.762v44.186H362.451V379.762h-19.5V364.573h57.995v15.189Z",
    transform: "translate(-145.839 -363.538)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    transform: "translate(31.611 23.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14875",
    "data-name": "Path 14875",
    d: "M163.006,423.947V364.573h19.073v59.374Z",
    transform: "translate(-163.006 -364.573)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2734",
    "data-name": "Group 2734",
    transform: "translate(333.357 30.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2733",
    "data-name": "Group 2733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14876",
    "data-name": "Path 14876",
    d: "M397.118,379.745V366.2h-5.295v-1.626h12.308V366.2h-5.295v13.546Z",
    transform: "translate(-391.823 -364.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14877",
    "data-name": "Path 14877",
    d: "M402.807,379.745V364.573H404.8l5.432,7.195,5.341-7.195h1.994v15.172h-1.72v-12.56l-5.615,7.219-5.707-7.219v12.56Z",
    transform: "translate(-388.322 -364.573)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2737",
    "data-name": "Group 2737",
    transform: "translate(139.106 456.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2736",
    "data-name": "Group 2736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14878",
    "data-name": "Path 14878",
    d: "M145.8,443.747v-6.322l-6.708-9.654h2.2l5.405,7.771,5.405-7.771h2.2l-6.683,9.654v6.322Z",
    transform: "translate(-139.089 -426.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14879",
    "data-name": "Path 14879",
    d: "M157.608,443.041a5.944,5.944,0,0,1-3.185-.833,5.543,5.543,0,0,1-2.076-2.256,7.182,7.182,0,0,1,0-6.285,5.562,5.562,0,0,1,2.076-2.244,6.536,6.536,0,0,1,6.383,0,5.6,5.6,0,0,1,2.062,2.244,7.182,7.182,0,0,1,0,6.285,5.584,5.584,0,0,1-2.062,2.256A5.936,5.936,0,0,1,157.608,443.041Zm0-1.641A3.841,3.841,0,0,0,161.3,439.1a5.658,5.658,0,0,0,0-4.573,4.072,4.072,0,0,0-7.385,0,5.658,5.658,0,0,0,0,4.573,3.872,3.872,0,0,0,3.692,2.305Z",
    transform: "translate(-135.094 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14880",
    "data-name": "Path 14880",
    d: "M169.077,442.995a4.908,4.908,0,0,1-2.341-.591,4.559,4.559,0,0,1-1.8-1.762,5.615,5.615,0,0,1-.687-2.884v-7.022h1.811v6.973a3.672,3.672,0,0,0,.952,2.643,3.2,3.2,0,0,0,2.425,1,3.583,3.583,0,0,0,3.645-3.669v-6.95h1.809V442.8h-1.809v-1.883a6.068,6.068,0,0,1-1.593,1.472A4.389,4.389,0,0,1,169.077,442.995Z",
    transform: "translate(-131.07 -425.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14881",
    "data-name": "Path 14881",
    d: "M176.529,442.849V430.783h1.809v2.968a5.128,5.128,0,0,1,.375-.833,4.511,4.511,0,0,1,4.066-2.328h.121V432.4h-.218a3.765,3.765,0,0,0-2.329.736,4.742,4.742,0,0,0-1.5,1.907,6.076,6.076,0,0,0-.52,2.5v5.309Z",
    transform: "translate(-127.156 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14882",
    "data-name": "Path 14882",
    d: "M190.692,443.747V427.771h7.191a5.637,5.637,0,0,1,4.03,1.389,5.52,5.52,0,0,1,0,7.5,5.636,5.636,0,0,1-4.03,1.387H192.5v5.7Zm1.809-7.385h5.26a3.986,3.986,0,0,0,2.848-.917,3.777,3.777,0,0,0,0-5.044,3.992,3.992,0,0,0-2.848-.916H192.5Z",
    transform: "translate(-122.642 -426.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14883",
    "data-name": "Path 14883",
    d: "M209.137,443.041a5.947,5.947,0,0,1-3.185-.833,5.551,5.551,0,0,1-2.076-2.256,7.182,7.182,0,0,1,0-6.285,5.571,5.571,0,0,1,2.076-2.244,6.536,6.536,0,0,1,6.383,0,5.594,5.594,0,0,1,2.062,2.244,7.182,7.182,0,0,1,0,6.285,5.574,5.574,0,0,1-2.062,2.256A5.933,5.933,0,0,1,209.137,443.041Zm0-1.641a3.838,3.838,0,0,0,3.692-2.305,5.658,5.658,0,0,0,0-4.573,4.072,4.072,0,0,0-7.385,0,5.658,5.658,0,0,0,0,4.573,3.872,3.872,0,0,0,3.692,2.305Z",
    transform: "translate(-118.67 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14884",
    "data-name": "Path 14884",
    d: "M215.871,442.849V430.783h1.809v2.968a5.019,5.019,0,0,1,.375-.833,4.607,4.607,0,0,1,2.148-1.954,4.53,4.53,0,0,1,1.917-.373h.121V432.4h-.218a3.762,3.762,0,0,0-2.329.736,4.756,4.756,0,0,0-1.5,1.907,6.1,6.1,0,0,0-.518,2.5v5.309Z",
    transform: "translate(-114.617 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14885",
    "data-name": "Path 14885",
    d: "M225.6,443.846V433.373h-2.462V431.78H225.6v-4.319h1.809v4.319h2.775v1.593h-2.775v10.473Z",
    transform: "translate(-112.301 -426.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14886",
    "data-name": "Path 14886",
    d: "M236.9,443.041a5.528,5.528,0,0,1-5.117-3.09,7.182,7.182,0,0,1,0-6.285,5.541,5.541,0,0,1,5.117-3.077,5.336,5.336,0,0,1,2.569.579,4.892,4.892,0,0,1,1.75,1.569v-1.956h1.809v12.066h-1.809v-1.931a4.989,4.989,0,0,1-1.75,1.544A5.337,5.337,0,0,1,236.9,443.041Zm.241-1.641a3.838,3.838,0,0,0,3.691-2.305,5.644,5.644,0,0,0,0-4.573,3.848,3.848,0,0,0-3.691-2.292,4.019,4.019,0,0,0-3.765,2.292,5.4,5.4,0,0,0,0,4.573,4.068,4.068,0,0,0,1.472,1.677A4.121,4.121,0,0,0,237.141,441.4Z",
    transform: "translate(-109.776 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14887",
    "data-name": "Path 14887",
    d: "M244.344,443.969V427.076h1.811v16.893Z",
    transform: "translate(-105.542 -427.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14888",
    "data-name": "Path 14888",
    d: "M257.236,443.846V433.373h-2.461V431.78h2.461v-4.319h1.809v4.319h2.776v1.593h-2.776v10.473Z",
    transform: "translate(-102.218 -426.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14889",
    "data-name": "Path 14889",
    d: "M268.682,443.041a5.947,5.947,0,0,1-3.185-.833,5.542,5.542,0,0,1-2.076-2.256,7.182,7.182,0,0,1,0-6.285,5.561,5.561,0,0,1,2.076-2.244,6.536,6.536,0,0,1,6.383,0,5.594,5.594,0,0,1,2.062,2.244,7.182,7.182,0,0,1,0,6.285,5.575,5.575,0,0,1-2.062,2.256A5.933,5.933,0,0,1,268.682,443.041Zm0-1.641a3.838,3.838,0,0,0,3.693-2.305,5.659,5.659,0,0,0,0-4.573,4.072,4.072,0,0,0-7.385,0,5.659,5.659,0,0,0,0,4.573,3.872,3.872,0,0,0,3.692,2.305Z",
    transform: "translate(-99.692 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14890",
    "data-name": "Path 14890",
    d: "M283.275,443.846V433.373h-2.461V431.78h2.461v-4.319h1.809v4.319h2.776v1.593h-2.776v10.473Z",
    transform: "translate(-93.918 -426.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14891",
    "data-name": "Path 14891",
    d: "M289.487,443.969V427.076H291.3v6.708a6.089,6.089,0,0,1,1.593-1.472,4.4,4.4,0,0,1,2.413-.6,4.886,4.886,0,0,1,2.353.591,4.582,4.582,0,0,1,1.787,1.762,5.6,5.6,0,0,1,.687,2.883v7.023h-1.811V437a3.69,3.69,0,0,0-.942-2.643,3.191,3.191,0,0,0-2.436-1,3.7,3.7,0,0,0-1.834.458,3.492,3.492,0,0,0-1.315,1.292,3.669,3.669,0,0,0-.5,1.917v6.951Z",
    transform: "translate(-91.154 -427.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14892",
    "data-name": "Path 14892",
    d: "M307.213,443.041a6.075,6.075,0,0,1-3.21-.833,5.764,5.764,0,0,1-2.136-2.256,6.564,6.564,0,0,1-.76-3.137,6.8,6.8,0,0,1,.724-3.148,5.571,5.571,0,0,1,2.076-2.244,6.536,6.536,0,0,1,6.383,0,5.607,5.607,0,0,1,2.064,2.244,6.8,6.8,0,0,1,.723,3.148v.725H302.965a4.937,4.937,0,0,0,.688,1.942,3.986,3.986,0,0,0,1.46,1.4,4.227,4.227,0,0,0,2.124.52,3.843,3.843,0,0,0,2.147-.568,3.98,3.98,0,0,0,1.352-1.459h1.978a5.917,5.917,0,0,1-1.991,2.643A5.685,5.685,0,0,1,307.213,443.041Zm-4.223-7.191H311.2a4.481,4.481,0,0,0-1.3-2.582,3.837,3.837,0,0,0-2.8-1.038,3.792,3.792,0,0,0-2.786,1.038A4.639,4.639,0,0,0,302.99,435.85Z",
    transform: "translate(-87.451 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14893",
    "data-name": "Path 14893",
    d: "M323.372,443.747,318.4,427.771h1.906l4.1,13.418,4.3-13.418h2.074l4.3,13.418,4.1-13.418h1.907l-4.97,15.976h-2.052l-4.319-13.418-4.32,13.418Z",
    transform: "translate(-81.939 -426.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14894",
    "data-name": "Path 14894",
    d: "M343.6,443.041a5.947,5.947,0,0,1-3.185-.833,5.543,5.543,0,0,1-2.076-2.256,7.182,7.182,0,0,1,0-6.285,5.562,5.562,0,0,1,2.076-2.244,6.536,6.536,0,0,1,6.383,0,5.594,5.594,0,0,1,2.062,2.244,7.182,7.182,0,0,1,0,6.285,5.574,5.574,0,0,1-2.062,2.256A5.933,5.933,0,0,1,343.6,443.041Zm0-1.641a3.838,3.838,0,0,0,3.692-2.305,5.658,5.658,0,0,0,0-4.573,4.072,4.072,0,0,0-7.385,0,5.658,5.658,0,0,0,0,4.573A3.872,3.872,0,0,0,343.6,441.4Z",
    transform: "translate(-75.815 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14895",
    "data-name": "Path 14895",
    d: "M350.332,442.849V430.783h1.809v2.968a5.011,5.011,0,0,1,.375-.833,4.607,4.607,0,0,1,2.148-1.954,4.53,4.53,0,0,1,1.917-.373h.121V432.4h-.218a3.762,3.762,0,0,0-2.329.736,4.757,4.757,0,0,0-1.5,1.907,6.1,6.1,0,0,0-.518,2.5v5.309Z",
    transform: "translate(-71.762 -425.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14896",
    "data-name": "Path 14896",
    d: "M358.474,443.969V427.076h1.809v16.893Z",
    transform: "translate(-69.166 -427.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14897",
    "data-name": "Path 14897",
    d: "M369.329,444.161a5.529,5.529,0,0,1-5.117-3.09,7.182,7.182,0,0,1,0-6.285,5.541,5.541,0,0,1,5.117-3.077,5.336,5.336,0,0,1,2.569.579,4.9,4.9,0,0,1,1.75,1.569v-6.782h1.809v16.893h-1.809v-1.931a5,5,0,0,1-1.75,1.544A5.336,5.336,0,0,1,369.329,444.161Zm.24-1.641a3.838,3.838,0,0,0,3.692-2.305,5.658,5.658,0,0,0,0-4.573,3.848,3.848,0,0,0-3.692-2.292,4.018,4.018,0,0,0-3.764,2.292,5.4,5.4,0,0,0,0,4.573,4.068,4.068,0,0,0,1.472,1.677A4.113,4.113,0,0,0,369.569,442.521Z",
    transform: "translate(-67.568 -427.076)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvistlogin);
export default __webpack_public_path__ + "static/media/ivistlogin.1fb5ce9b4759936b482f1ff3e39e28ff.svg";
export { ForwardRef as ReactComponent };